var render = function render(){var _vm=this,_c=_vm._self._c;return _c('app-menu',{attrs:{"items":_vm.items,"min-width":"180"},scopedSlots:_vm._u([{key:"activator",fn:function({ attrs, on }){return [_c('app-btn',_vm._g(_vm._b({},'app-btn',attrs,false),on),[_vm._v(" "+_vm._s(_vm.$t('support'))+" "),_c('app-chevron-down')],1)]}}])})
}
var staticRenderFns = []

export { render, staticRenderFns }